<template>
  <div class="page-shell">
    <div class="page-panel">
      <h1>Acesso permitido somente a usuarios autorizados</h1>
      <p>Seu perfil nao possui permissao para acessar esta area.</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>
